import { Usecase } from '..'

export class InspectApplicationUsecase extends Usecase {
    invoke (): void {
        if (this.browserService.isInspecting()) {
            this.logger.info('Application is in inspection mode', this)
        }
    }
}
